import { TableList } from '@ui/components/elements'
import { MenuItem } from '@ui/components/elements/TableList/TableList'
import { Spinner } from '@ui/components/loaders'
import { Member } from '@ui/interfaces'

interface MembersProps {
  members: Member[]
  loading: boolean
  menuItems: MenuItem[]
  currentMember: Member
  isOnlyMember: boolean
}

export const Members = ({ members, loading, menuItems, currentMember, isOnlyMember }: MembersProps) => {
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }
  return (
    <div className="w-full">
      {isOnlyMember ? (
        <div>No members</div>
      ) : (
        <TableList
          items={members
            .map((member) => ({ id: member.id, email: member.email, role: member.role }))
            .filter((member) => member.email !== currentMember.email)}
          menuItems={menuItems}
        />
      )}
    </div>
  )
}
